var _style, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaexposure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#333333;}\n\t.st1{fill:#FFA64D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,47.3c-12.2,0-22.1-9.9-22.1-22.1C2.9,13,12.9,3.1,25,3.1S47.2,13,47.2,25.2c0,2.1-0.3,4.2-0.9,6.2 c-0.1,0.2-0.3,0.3-0.5,0.3c-0.2-0.1-0.3-0.3-0.3-0.5c0.6-1.9,0.9-4,0.9-6c0-11.8-9.6-21.3-21.3-21.3S3.7,13.5,3.7,25.2 C3.7,37,13.3,46.5,25,46.5c0.2,0,0.4,0.2,0.4,0.4C25.4,47.2,25.3,47.3,25,47.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,50.2c-13.8,0-25-11.2-25-25c0-2.4,0.3-4.8,1-7c0.1-0.2,0.3-0.4,0.6-0.3c0.3,0,0.4,0.3,0.4,0.5 c-0.6,2.2-1,4.5-1,6.8c0,13.3,10.8,24.1,24,24.1s24.1-10.8,24.1-24.1S38.3,1.2,25,1.2c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4 c13.8,0,25,11.2,25,25S38.8,50.2,25,50.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.3,22.6h4.9v2.7c0,0.5-0.4,0.9-0.9,0.9h-4.9v-2.7C25.4,23.1,25.9,22.6,26.3,22.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.2,
    y: 19.1,
    className: "st1",
    width: 1.8,
    height: 6.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.2,18.2L33,19.5h-1.2v-0.4c0-0.7-0.6-1.3-1.3-1.3h-0.5c0.6-0.6,0.9-1.4,0.9-2.2c0-1.7-1.4-3.1-3.1-3.1 c-1.5,0-2.7,1-3,2.3c-0.4-0.3-0.9-0.5-1.5-0.5c-1.2,0-2.2,1-2.2,2.2c0,0.5,0.2,1,0.5,1.3h-2.7c-0.6,0-1.1,0.4-1.3,0.9h-1.9V24h1.8 v1.3c0,0.7,0.6,1.3,1.3,1.3v1.8h-2.2v-0.9h-5.4v2.7h5.4v-0.9h3.1v-2.7h2.2v1.8h1.3v4.8l-4.4,6.9h2.9l1.5-2.5v2.5h2.7v-2.5l1.5,2.5 h2.9l-4.4-6.9v-4.8h1.3v-1.8h3.1c0.7,0,1.3-0.6,1.3-1.3v-0.4H33l2.2,1.3h3.7v-8.1H35.2z M15.6,29.4H12v-0.9h3.6V29.4z M27.7,13.2 c1.2,0,2.2,1,2.2,2.2s-1,2.2-2.2,2.2c-1.2,0-2.2-1-2.2-2.2S26.5,13.2,27.7,13.2z M25.5,17.7H25c0.1-0.1,0.2-0.2,0.2-0.3 C25.3,17.5,25.4,17.6,25.5,17.7z M21.9,16.4c0-0.7,0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3S21.9,17.1,21.9,16.4z  M16.5,23.1v-3.6h0.9v3.6H16.5z M18.7,25.8c-0.2,0-0.4-0.2-0.4-0.4v-6.3c0-0.2,0.2-0.4,0.4-0.4h11.7c0.2,0,0.4,0.2,0.4,0.4v0.4 v2.7h-4.5c-0.7,0-1.3,0.6-1.3,1.3v2.2h-3.1H18.7z M21.2,39.3h-0.7l2.8-4.3v1L21.2,39.3z M28.7,39.3h-0.7l-2-3.3v-1L28.7,39.3z  M25,39.3h-0.9V28.5H25V39.3z M26.3,27.6h-0.4h-2.7h-0.4v-0.9h3.6V27.6z M30.8,25.3c0,0.2-0.2,0.4-0.4,0.4h-3.1h-1.3v-2.2 c0-0.2,0.2-0.4,0.4-0.4h0.4v1.8h0.9v-1.8h0.9v1.8h0.9v-1.8h1.3v1.8V25.3z M32.6,24h-0.9v-3.6h0.9V24z M38,25.3h-0.9v-0.9h-0.9v0.9 h-0.8l-1.9-1.2v-4l1.9-1.2h0.8v4.5h0.9v-4.5H38V25.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.7,16.8c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3S27,16.8,27.7,16.8z M27.7,15 c0.2,0,0.4,0.2,0.4,0.4s-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4S27.4,15,27.7,15z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 15.9,
    className: "st0",
    width: 0.9,
    height: 0.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaexposure);
export default __webpack_public_path__ + "static/media/mediaexposure.5aabc99d2a73f0dd290829862d3c8742.svg";
export { ForwardRef as ReactComponent };